import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-audio-disabled';
export var ID = 'icon-audio-disabled';
/* eslint-disable max-len */

export var SVGAudioDisabled = function SVGAudioDisabled() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M16,13l-3-2.06L10.35,9.12h0L6.06,6.17,5,5.44,0,2V3L5,6.44v4.83A2,2,0,1,0,6,13V7.12L9.61,9.6A2,2,0,0,0,9,11a2,2,0,0,0,3.82.82L16,14Z"
  }), React.createElement("polygon", {
    points: "12 4.31 12 9.25 13 9.94 13 4 13 0 5 2.5 5 4.44 7.06 5.86 12 4.31"
  }));
};
/* eslint-disable max-len */

var AudioDisabled = function AudioDisabled(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAudioDisabled
  });
};

AudioDisabled.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default AudioDisabled;